import React from "react";
import { Col, Row } from "react-bootstrap";
import {AiFillHtml5} from "react-icons/ai";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,

  DiGit,

} from "react-icons/di";
import {
  SiMysql,
  SiTailwindcss,
  SiDocker,
  SiGithubactions,
  SiSnyk,
  SiExpress,
  SiTypescript
} from "react-icons/si";
import { IoLogoCss3 } from "react-icons/io";

import {FaBootstrap} from "react-icons/fa";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col xs={4} md={2} className="tech-icons">
        <AiFillHtml5 />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <IoLogoCss3 />
      </Col>
 
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
  
     <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
   <Col xs={4} md={2} className="tech-icons">
    <FaBootstrap /> 
      </Col>
      <Col xs={4} md={2} className="tech-icons">
    <SiTailwindcss /> 
      </Col>


      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>

   
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
  <Col xs={4} md={2} className="tech-icons">  
  <SiDocker />
  </Col>
<Col xs={4} md={2} className="tech-icons">  
  <SiGithubactions />
  </Col>
<Col xs={4} md={2} className="tech-icons">
  <SiSnyk />
  </Col>
    <Col xs={4} md={2} className="tech-icons">
  <SiExpress />
  </Col>
  
    </Row>
  );
}

export default Techstack;
